import { render, staticRenderFns } from "./DocumentsIco.vue?vue&type=template&id=8dea0446&"
import script from "./DocumentsIco.vue?vue&type=script&lang=js&"
export * from "./DocumentsIco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports